import { inject, Orientation, ScaleProvider, ScreenOrientationService, service } from "@spawn/core";

@service
export class FGViewUtils {
	@inject protected screenOrientationService!: ScreenOrientationService;
	@inject protected scaleProvider!: ScaleProvider;

	get isPortraitMobile(): boolean {
		return this.screenOrientationService.orientation === Orientation.Portrait && this.scaleProvider.aspectRatio <= 0.6;
	}
	get gameConsole(): HTMLElement | null {
		return document.querySelector("[class^='gameMessage']") as HTMLElement;
	}

	public setGameConsoleVisibility(visible: boolean): void {
		if (this.gameConsole) {
			this.gameConsole.style.visibility = visible ? "visible" : "hidden";
		}
	}
}
